import * as React from "react";
const SvgFiRrLightbulbDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lightbulb-dollar_svg__a)">
      <path
        fill="#062147"
        d="M17.994 2.286A9.05 9.05 0 0 0 10.956.06C6.904.517 3.59 3.782 3.075 7.822c-.374 2.931.644 5.76 2.793 7.761C7.243 16.863 8 18.483 8 20.15v.161A3.694 3.694 0 0 0 11.69 24h.619a3.694 3.694 0 0 0 3.69-3.69v-.549c0-1.486.687-2.906 1.932-3.998A9 9 0 0 0 20.999 9a9.01 9.01 0 0 0-3.005-6.714M12.309 22h-.619c-.932 0-1.69-.758-1.69-1.69v-.16L9.998 20H14v.31c0 .932-.759 1.69-1.69 1.69zm4.304-7.74c-1.177 1.031-1.998 2.34-2.376 3.74H9.689c-.42-1.43-1.258-2.765-2.458-3.88-1.671-1.557-2.463-3.76-2.171-6.044.399-3.138 2.974-5.673 6.121-6.029q.417-.046.828-.047c1.725 0 3.353.617 4.652 1.778a6.993 6.993 0 0 1-.048 10.481M16 12c0 1.654-1.346 3-3 3v1a1 1 0 1 1-2 0v-1h-.268a3.01 3.01 0 0 1-2.598-1.499 1 1 0 1 1 1.73-1c.179.307.511.5.867.5h2.268c.552 0 1-.45 1-1a.77.77 0 0 0-.644-.76l-3.041-.508A2.76 2.76 0 0 1 7.999 8c0-1.654 1.346-3 3-3V4a1 1 0 1 1 2 0v1h.268c1.067 0 2.063.575 2.598 1.5a1 1 0 1 1-1.73 1.001 1 1 0 0 0-.867-.5H11c-.552 0-1 .45-1 1 0 .378.271.698.644.76l3.041.507A2.76 2.76 0 0 1 16 12.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lightbulb-dollar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLightbulbDollar;
